var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    staticClass: "stroke-current",
    attrs: {
      "d": "M14.3333 9.88873V15.2221C14.3333 15.6936 14.146 16.1457 13.8126 16.4791C13.4792 16.8125 13.0271 16.9998 12.5556 16.9998H2.77778C2.30628 16.9998 1.8541 16.8125 1.5207 16.4791C1.1873 16.1457 1 15.6936 1 15.2221V5.44428C1 4.97279 1.1873 4.5206 1.5207 4.1872C1.8541 3.8538 2.30628 3.6665 2.77778 3.6665H8.11111",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _c('path', {
    staticClass: "stroke-current",
    attrs: {
      "d": "M11.6665 1H16.9998V6.33333",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  }), _c('path', {
    staticClass: "stroke-current",
    attrs: {
      "d": "M7.22217 10.7778L16.9999 1",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };